export default __webpack_public_path__ + "static/media/SuburbanReact.2426113e.jpeg";